<template>
  <component :is="componentType" :to="route">
    {{ title }}
  </component>
</template>

<script>
import { GuiLink } from "@thegetty-private/getty-ui";
export default {
  name: "LinkOrText",
  components: {
    GuiLink
  },
  props: {
    /**
     * The title of the Object
     */
    title: {
      type: String,
      required: true
    },
    /**
     * The route, if there's a link
     */
    route: {
      type: Object,
      required: false,
      default: () => undefined
    }
  },
  computed: {
    /**
     * The Type of component (a span prior to being a link)
     */
    componentType() {
      if (this.route != undefined) {
        return "GuiLink";
      }
      return "span";
    }
  }
};
</script>

<style></style>
